import './Tooltip.css';
import React from 'react'
import ReactDOMServer from 'react-dom/server';
import { COLORS } from '../Consts/LineChartConsts';
import SensorDataProvider from '../../../Services/SensorDataProvider';

class Tooltip {
  constructor({chart, container, ppmSeries, tempSeries, rhSeries, getSize}) {
    this.chart = chart;
    this.container = container;
    this.ppmSeries = ppmSeries;
    this.tempSeries = tempSeries;
    this.rhSeries = rhSeries;
		this.getChartSize = getSize;
  }

  renderMeasure(label, value, color) {
    return (
      <React.Fragment>
        <div style={{color}}>{label}</div>
        <div className="line-chart-tooltip__series-label">{value}</div>
      </React.Fragment>
    )
  }

	renderTooltipContent(param) {
		const dateStr = new Date(param.time * 1000).toLocaleString();
		const ppm = param.seriesPrices.get(this.ppmSeries);
		const rh = param.seriesPrices.get(this.rhSeries);
		const temp = param.seriesPrices.get(this.tempSeries);

		return (
			<React.Fragment>
        {this.renderMeasure('°C', temp, COLORS.RED)}
        {this.renderMeasure('RH', rh, COLORS.YELLOW)}
        {this.renderMeasure('PPM', ppm, COLORS.BLUE)}
				<div className="line-chart-tooltip__series-date">{dateStr}</div>
			</React.Fragment>
		)
	}

  renderTooltipContainer() {
		const toolTip = document.createElement('div');
		toolTip.className = 'line-chart-tooltip';

		this.container.appendChild(toolTip);
    return toolTip;
  }

	getRenderTooltipFunc(toolTip) {
		const toolTipWidth = 96;
		const leftScaleWidth = 56;
		const leftTooltipMargin = 10;
		const bottomAxisHeight = 27;

		return (param) => {
			const {
				width,
				height
			} = this.getChartSize();
			let leftPosition = null;

			if (!param.time || param.point.x < 0 || param.point.x > width || param.point.y < 0 || param.point.y > height) {
				toolTip.style.display = 'none';
				return;
			}
		
			if (param.point.x < toolTipWidth + leftTooltipMargin) {
				leftPosition = leftScaleWidth;
			} else {
				leftPosition = param.point.x - toolTipWidth / 2;
			}

			toolTip.style.display = 'block';
			toolTip.style.left = `${leftPosition}px`;
			toolTip.style.bottom = `${bottomAxisHeight}px`;
			toolTip.innerHTML = ReactDOMServer.renderToStaticMarkup(this.renderTooltipContent(param));
		}
	}

	render() {
    const toolTipContainer = this.renderTooltipContainer();
    const renderTooltipFunc = this.getRenderTooltipFunc(toolTipContainer);

		this.chart.subscribeCrosshairMove(renderTooltipFunc);
		// this.chart.subscribeClick(renderTooltipFunc); // might be good for phones
	}
}

export default Tooltip;